import { convertDateToYYYYMMDDFormat } from '@repo/ui';
import { AcademicManagementFollowUpQuery } from 'domain/models';
import {
  ExportAcademicManagementGroups,
  ExportAcademicManagementInternshipLocations,
  ExportAcademicManagementProfessionals,
  ExportAcademicManagementTasks,
  GetAcademicManagementGroups,
  GetAcademicManagementInternshipLocations,
  GetAcademicManagementProfessionals,
  GetAcademicManagementTasks,
} from 'domain/usecases';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { useAcademicOverview } from '../../hooks/useAcademicOverview';
import { AcademicOverviewView } from './view';
interface IProps {
  getGroups: GetAcademicManagementGroups;
  getTasks: GetAcademicManagementTasks;
  getInternshipLocations: GetAcademicManagementInternshipLocations;
  getProfessionals: GetAcademicManagementProfessionals;
  exportGroups: ExportAcademicManagementGroups;
  exportTasks: ExportAcademicManagementTasks;
  exportInternshipLocations: ExportAcademicManagementInternshipLocations;
  exportProfessionals: ExportAcademicManagementProfessionals;
}

export const AcademicOverview = (props: IProps) => {
  const {
    activeTab,
    exportingReport,
    filters,
    groups,
    tasks,
    internshipLocations,
    professionals,
    saveFilters,
    submitFilters,
    changeTab,
    changePage,
    changeRowsPerPage,
    search,
    exportReport,
  } = useAcademicOverview(props);

  const todaysDate = new Date();
  const firstDayOfMonth = new Date(
    todaysDate.getFullYear(),
    todaysDate.getMonth(),
    1,
  );

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      entity: filters?.entity || null,
      course: filters?.course || null,
      semester: filters?.semester || null,
      unit: filters?.unit || null,
      groups: filters?.groups || [],
      starts: filters?.starts || convertDateToYYYYMMDDFormat(firstDayOfMonth),
      ends: filters?.ends || convertDateToYYYYMMDDFormat(todaysDate),
    },
    validationSchema: Yup.object({
      entity: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      course: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      semester: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      unit: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      groups: Yup.array().of(
        Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable(),
      ),
      starts: Yup.date().required('Campo é obrigatório!'),
      ends: Yup.date().required('Campo é obrigatório!'),
    }),

    onSubmit: (values) => {
      const valuesToSubmit: AcademicManagementFollowUpQuery = {
        entityHashId: values.entity?.value,
        courseHashId: values.course?.value,
        semesterId: values.semester?.value,
        curricularUnitHashId: values.unit?.value,
        groupHashIds: values.groups.length
          ? values.groups.map((group) => group.value)
          : undefined,
        start: values.starts,
        end: values.ends,
      };

      saveFilters({ ...values });
      submitFilters(valuesToSubmit);
    },
  });

  const getCurrentFilterParams = () => ({
    entityHashId: validation.values.entity?.value,
    courseHashId: validation.values.course?.value,
    semesterId: validation.values.semester?.value,
    curricularUnitHashId: validation.values.unit?.value,
    groupHashIds: validation.values.groups.length
      ? validation.values.groups.map((group) => group.value)
      : undefined,
    start: validation.values.starts,
    end: validation.values.ends,
  });

  return (
    <AcademicOverviewView
      activeTab={activeTab}
      exportingReport={exportingReport}
      groups={groups}
      tasks={tasks}
      internshipLocations={internshipLocations}
      professionals={professionals}
      validation={validation}
      onTabChange={changeTab}
      onChangePage={changePage}
      onChangeRowsPerPage={changeRowsPerPage}
      onSearch={search}
      onExport={(report) => exportReport(report, getCurrentFilterParams())}
    />
  );
};
